import { IconButton, Tooltip } from 'components/mui';
import { InfoIcon } from 'components/icons';

const AssignedPatrolButton = ({
	numberOfAssignedPatrols,
	setShowAssignedPatrols,
}) => {
	return (
		<Tooltip
			title={
				numberOfAssignedPatrols > 0
					? `This checklist is assigned to ${numberOfAssignedPatrols} patrol(s). Click to view more info.`
					: "This checklist isn't assigned to any patrols."
			}
			placement="top"
		>
			<IconButton
				onClick={
					numberOfAssignedPatrols > 0
						? () => setShowAssignedPatrols(true)
						: null
				}
				color={numberOfAssignedPatrols > 0 ? 'primary' : 'secondary'}
			>
				<InfoIcon />
			</IconButton>
		</Tooltip>
	);
};
export default AssignedPatrolButton;
